import { useEffect, useRef, useState } from "react";
import axios from "../lib/axios";

export default function useStoreAdminAuth() {
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [storeId, setStoreId] = useState(null);
  const [username, setUsername] = useState(null);
  const [storeName, setStoreName] = useState(null);
  const [isSuper, setIsSuper] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    let alive = true;

    const checkOnce = async () => {
      try {
        const { data } = await axios.get("/store-admin/check");
        if (!alive) return;

        setLoggedIn(!!data.logged_in);
        setStoreId(data.store_id ?? null);
        setUsername(data.username ?? null);
        setStoreName(data.store_name ?? null);
        setIsSuper(!!data.is_super);
      } catch (e) {
        if (!alive) return;
        setLoggedIn(false);
        setStoreId(null);
        setUsername(null);
        setStoreName(null);
        setIsSuper(false);
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    };

    // ✅ 최초 1회 즉시 체크
    checkOnce();

    // ✅ 10초마다 체크 (상위관리자 비활성화 감지용)
    timerRef.current = setInterval(() => {
      checkOnce();
    }, 10000);

    return () => {
      alive = false;
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  return { loading, loggedIn, storeId, username, storeName, isSuper };
}